<template>
  <div class="remain">
    <balance-recharge type='1' :exclusive='1'/>
  </div>
</template>

<script>
import balanceRecharge from './balanceRecharge.vue'
export default {
  components:{
    balanceRecharge
  },
  props:{},
  data(){
    return {
    }
  },
  watch:{},
  computed:{},
  methods:{},
  created(){},
  mounted(){}
}
</script>
<style lang="scss" scoped>

</style>